"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runtypeImplementing = void 0;
var runtypeImplementing = function (_implementing) { return function (payload) { return payload; }; };
exports.runtypeImplementing = runtypeImplementing;
//# sourceMappingURL=runtypeImplementing.js.map